export default __webpack_public_path__ + "static/media/hubano.416e689e.png";